// extracted by mini-css-extract-plugin
export var printerCard = "_fn-1";
export var printerCardConfigured = "_fn-2";
export var printerCardError = "_fn-3";
export var printerCardsContainer = "_fn-0";
export var printerIcon = "_fn-8";
export var printerIconConfigured = "_fn-5";
export var printerIconContainer = "_fn-4";
export var printerIconError = "_fn-6";
export var printerIconUnconfigured = "_fn-7";
export var workstationsTableCard = "_fn-9";